import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@sparro/env/environment';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AiChatBotService {
  private baseUrl: string;

  constructor(private http: HttpClient, private metaService: MetaService) {
    this.baseUrl = `${environment.serverUrl}${environment.baseUrl}`;
  }

  getCategories() {
    return this.http.get(this.baseUrl + 'message_category/');
  }

  createChat(data) {
    return this.http.post(this.baseUrl + 'chatbot/', data);
  }

  getChats(page: number) {
    return this.http.get(this.baseUrl + 'chatbot/?page=' + page);
  }

  getReply(data) {
    return this.http.post(this.baseUrl + 'chatbot/make_query/', data).pipe(
      map(response => {
        return this.metaService.decodeApiResponse(response, true);
      })
    );
  }

  regenerate(id: number) {
    return this.http.get(`${this.baseUrl}chatbot/${id}/regenerate_query/`).pipe(
      map(response => {
        return this.metaService.decodeApiResponse(response, true);
      })
    );
  }

  getEditedResponse(data) {
    return this.http.post(this.baseUrl + 'chatbot/make_edits/', data).pipe(
      map(response => {
        return this.metaService.decodeApiResponse(response, true);
      })
    );
  }
}
